import { render, staticRenderFns } from "./WDialog.vue?vue&type=template&id=67b71df5&scoped=true"
import script from "./WDialog.vue?vue&type=script&lang=js"
export * from "./WDialog.vue?vue&type=script&lang=js"
import style0 from "./WDialog.vue?vue&type=style&index=0&id=67b71df5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b71df5",
  null
  
)

export default component.exports